/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBoolean,
  ApiEnvelopeGrantCatalogResponse,
  ApiEnvelopeGrantMutationResponse,
  ApiEnvelopeTenantGrantSummaryDto,
  ApiEnvelopeUserGrantSummaryDto,
  AssignFromPoolRequest,
  GrantsRevokeParams,
  SetPoolRequest,
  SetUserDirectRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type grantsCatalogResponse200 = {
  data: ApiEnvelopeGrantCatalogResponse
  status: 200
}

export type grantsCatalogResponse401 = {
  data: ApiEnvelopeGrantCatalogResponse
  status: 401
}

export type grantsCatalogResponseSuccess = (grantsCatalogResponse200) & {
  headers: Headers;
};
export type grantsCatalogResponseError = (grantsCatalogResponse401) & {
  headers: Headers;
};

export type grantsCatalogResponse = (grantsCatalogResponseSuccess | grantsCatalogResponseError)

export const getGrantsCatalogUrl = () => {




  return `/api/grants/catalog`
}

export const useGrantsCatalogHook = (): ( options?: RequestInit) => Promise<grantsCatalogResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getGrantsCatalogUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type grantsMeResponse200 = {
  data: ApiEnvelopeUserGrantSummaryDto
  status: 200
}

export type grantsMeResponse401 = {
  data: ApiEnvelopeUserGrantSummaryDto
  status: 401
}

export type grantsMeResponseSuccess = (grantsMeResponse200) & {
  headers: Headers;
};
export type grantsMeResponseError = (grantsMeResponse401) & {
  headers: Headers;
};

export type grantsMeResponse = (grantsMeResponseSuccess | grantsMeResponseError)

export const getGrantsMeUrl = () => {




  return `/api/grants/me`
}

export const useGrantsMeHook = (): ( options?: RequestInit) => Promise<grantsMeResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getGrantsMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type grantsUserSummaryResponse200 = {
  data: ApiEnvelopeUserGrantSummaryDto
  status: 200
}

export type grantsUserSummaryResponse401 = {
  data: ApiEnvelopeUserGrantSummaryDto
  status: 401
}

export type grantsUserSummaryResponse403 = {
  data: ApiEnvelopeUserGrantSummaryDto
  status: 403
}

export type grantsUserSummaryResponseSuccess = (grantsUserSummaryResponse200) & {
  headers: Headers;
};
export type grantsUserSummaryResponseError = (grantsUserSummaryResponse401 | grantsUserSummaryResponse403) & {
  headers: Headers;
};

export type grantsUserSummaryResponse = (grantsUserSummaryResponseSuccess | grantsUserSummaryResponseError)

export const getGrantsUserSummaryUrl = (userId: string,) => {




  return `/api/grants/user/${userId}`
}

export const useGrantsUserSummaryHook = (): (userId: string, options?: RequestInit) => Promise<grantsUserSummaryResponse> => {

      const customFetcher = useSfetchMutator();
      return (userId: string, options?: RequestInit) => {

        return customFetcher(getGrantsUserSummaryUrl(userId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type grantsTenantSummaryResponse200 = {
  data: ApiEnvelopeTenantGrantSummaryDto
  status: 200
}

export type grantsTenantSummaryResponse401 = {
  data: ApiEnvelopeTenantGrantSummaryDto
  status: 401
}

export type grantsTenantSummaryResponse403 = {
  data: ApiEnvelopeTenantGrantSummaryDto
  status: 403
}

export type grantsTenantSummaryResponseSuccess = (grantsTenantSummaryResponse200) & {
  headers: Headers;
};
export type grantsTenantSummaryResponseError = (grantsTenantSummaryResponse401 | grantsTenantSummaryResponse403) & {
  headers: Headers;
};

export type grantsTenantSummaryResponse = (grantsTenantSummaryResponseSuccess | grantsTenantSummaryResponseError)

export const getGrantsTenantSummaryUrl = (tenantId: string,) => {




  return `/api/grants/tenant/${tenantId}`
}

export const useGrantsTenantSummaryHook = (): (tenantId: string, options?: RequestInit) => Promise<grantsTenantSummaryResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string, options?: RequestInit) => {

        return customFetcher(getGrantsTenantSummaryUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type grantsSetTenantPoolResponse200 = {
  data: ApiEnvelopeGrantMutationResponse
  status: 200
}

export type grantsSetTenantPoolResponse400 = {
  data: ApiEnvelopeGrantMutationResponse
  status: 400
}

export type grantsSetTenantPoolResponse401 = {
  data: ApiEnvelopeGrantMutationResponse
  status: 401
}

export type grantsSetTenantPoolResponse403 = {
  data: ApiEnvelopeGrantMutationResponse
  status: 403
}

export type grantsSetTenantPoolResponseSuccess = (grantsSetTenantPoolResponse200) & {
  headers: Headers;
};
export type grantsSetTenantPoolResponseError = (grantsSetTenantPoolResponse400 | grantsSetTenantPoolResponse401 | grantsSetTenantPoolResponse403) & {
  headers: Headers;
};

export type grantsSetTenantPoolResponse = (grantsSetTenantPoolResponseSuccess | grantsSetTenantPoolResponseError)

export const getGrantsSetTenantPoolUrl = (tenantId: string,) => {




  return `/api/grants/admin/tenant/${tenantId}/pool`
}

export const useGrantsSetTenantPoolHook = (): (tenantId: string,
    setPoolRequest?: SetPoolRequest, options?: RequestInit) => Promise<grantsSetTenantPoolResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string,
    setPoolRequest?: SetPoolRequest, options?: RequestInit) => {

        return customFetcher(getGrantsSetTenantPoolUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setPoolRequest)
  }
);
      }
  }


export type grantsSetUserDirectResponse200 = {
  data: ApiEnvelopeGrantMutationResponse
  status: 200
}

export type grantsSetUserDirectResponse400 = {
  data: ApiEnvelopeGrantMutationResponse
  status: 400
}

export type grantsSetUserDirectResponse401 = {
  data: ApiEnvelopeGrantMutationResponse
  status: 401
}

export type grantsSetUserDirectResponse403 = {
  data: ApiEnvelopeGrantMutationResponse
  status: 403
}

export type grantsSetUserDirectResponseSuccess = (grantsSetUserDirectResponse200) & {
  headers: Headers;
};
export type grantsSetUserDirectResponseError = (grantsSetUserDirectResponse400 | grantsSetUserDirectResponse401 | grantsSetUserDirectResponse403) & {
  headers: Headers;
};

export type grantsSetUserDirectResponse = (grantsSetUserDirectResponseSuccess | grantsSetUserDirectResponseError)

export const getGrantsSetUserDirectUrl = (userId: string,) => {




  return `/api/grants/admin/user/${userId}/direct`
}

export const useGrantsSetUserDirectHook = (): (userId: string,
    setUserDirectRequest?: SetUserDirectRequest, options?: RequestInit) => Promise<grantsSetUserDirectResponse> => {

      const customFetcher = useSfetchMutator();
      return (userId: string,
    setUserDirectRequest?: SetUserDirectRequest, options?: RequestInit) => {

        return customFetcher(getGrantsSetUserDirectUrl(userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setUserDirectRequest)
  }
);
      }
  }


export type grantsAssignFromPoolResponse200 = {
  data: ApiEnvelopeGrantMutationResponse
  status: 200
}

export type grantsAssignFromPoolResponse400 = {
  data: ApiEnvelopeGrantMutationResponse
  status: 400
}

export type grantsAssignFromPoolResponse401 = {
  data: ApiEnvelopeGrantMutationResponse
  status: 401
}

export type grantsAssignFromPoolResponse403 = {
  data: ApiEnvelopeGrantMutationResponse
  status: 403
}

export type grantsAssignFromPoolResponseSuccess = (grantsAssignFromPoolResponse200) & {
  headers: Headers;
};
export type grantsAssignFromPoolResponseError = (grantsAssignFromPoolResponse400 | grantsAssignFromPoolResponse401 | grantsAssignFromPoolResponse403) & {
  headers: Headers;
};

export type grantsAssignFromPoolResponse = (grantsAssignFromPoolResponseSuccess | grantsAssignFromPoolResponseError)

export const getGrantsAssignFromPoolUrl = (tenantId: string,) => {




  return `/api/grants/tenant/${tenantId}/assign`
}

export const useGrantsAssignFromPoolHook = (): (tenantId: string,
    assignFromPoolRequest?: AssignFromPoolRequest, options?: RequestInit) => Promise<grantsAssignFromPoolResponse> => {

      const customFetcher = useSfetchMutator();
      return (tenantId: string,
    assignFromPoolRequest?: AssignFromPoolRequest, options?: RequestInit) => {

        return customFetcher(getGrantsAssignFromPoolUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assignFromPoolRequest)
  }
);
      }
  }


export type grantsRevokeResponse200 = {
  data: ApiEnvelopeBoolean
  status: 200
}

export type grantsRevokeResponse401 = {
  data: ApiEnvelopeBoolean
  status: 401
}

export type grantsRevokeResponse403 = {
  data: ApiEnvelopeBoolean
  status: 403
}

export type grantsRevokeResponse404 = {
  data: ApiEnvelopeBoolean
  status: 404
}

export type grantsRevokeResponseSuccess = (grantsRevokeResponse200) & {
  headers: Headers;
};
export type grantsRevokeResponseError = (grantsRevokeResponse401 | grantsRevokeResponse403 | grantsRevokeResponse404) & {
  headers: Headers;
};

export type grantsRevokeResponse = (grantsRevokeResponseSuccess | grantsRevokeResponseError)

export const getGrantsRevokeUrl = (grantId: string,
    params?: GrantsRevokeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/grants/${grantId}?${stringifiedParams}` : `/api/grants/${grantId}`
}

export const useGrantsRevokeHook = (): (grantId: string,
    params?: GrantsRevokeParams, options?: RequestInit) => Promise<grantsRevokeResponse> => {

      const customFetcher = useSfetchMutator();
      return (grantId: string,
    params?: GrantsRevokeParams, options?: RequestInit) => {

        return customFetcher(getGrantsRevokeUrl(grantId,params),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


